var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSpreadsheetActive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_174",
    "data-name": "Rect\\xE1ngulo 174",
    width: 34,
    height: 34,
    transform: "translate(729 129)",
    fill: "#85af26",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Enmascarar_grupo_2",
    "data-name": "Enmascarar grupo 2",
    transform: "translate(-729 -129)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_67",
    "data-name": "Grupo 67",
    transform: "translate(-50 4.711)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_48",
    "data-name": "Trazado 48",
    d: "M19.4,65.556v2.9h7.68V68.2c0-.656,0-2.312,0-2.968,0-.333.14-.478.464-.478q1.581,0,3.161,0c.319,0,.464.137.465.452,0,2.694,0,8.389,0,11.083,0,.335-.154.462-.531.462H20.458c-.453,0-.905,0-1.358,0-.371,0-.507-.136-.507-.51,0-2.663,0-8.326,0-10.989,0-.366.132-.5.49-.5h6.3c.323,0,.495.14.495.4s-.176.4-.5.4H19.4ZM30.358,75.943V65.573H27.9v2.9c.355,0,.7-.022,1.038.012a.5.5,0,0,1,.348.245.469.469,0,0,1-.07.4.508.508,0,0,1-.349.137c-.323.018-.648.006-.966.006V72.24c.348,0,.683,0,1.017,0a.4.4,0,0,1,.417.385.406.406,0,0,1-.4.409c-.109.008-.219,0-.328,0h-.722c0,.279,0,.521,0,.763a.4.4,0,1,1-.8-.007c0-.247,0-.494,0-.74H19.408v2.889ZM19.4,72.221h7.667V69.286H19.4Z",
    transform: "translate(771.305 72.936)",
    fill: "#85af26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_49",
    "data-name": "Trazado 49",
    d: "M21.791,46.244h2.6a1.855,1.855,0,0,1,.21.006.391.391,0,0,1,.075.761.931.931,0,0,1-.277.032q-2.611,0-5.223,0a1.384,1.384,0,0,1-.187-.006.393.393,0,0,1-.371-.429.376.376,0,0,1,.409-.362c.921,0,1.842,0,2.764,0Z",
    transform: "translate(771.284 88.252)",
    fill: "#85af26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_50",
    "data-name": "Trazado 50",
    d: "M18.379,4.929c0-.047,0-.094,0-.141a.422.422,0,0,0-.122-.268v0c-.014-.046-.073-.079-.112-.118L13.734,0H1.366C.374.344,0,.8,0,1.7Q0,12,0,22.3A1.6,1.6,0,0,0,1.7,24H16.669a2.148,2.148,0,0,0,.35-.019,1.587,1.587,0,0,0,1.359-1.648c0-5.062,0-12.341,0-17.4M16.822,4.2c.053.053.1.11.183.2a2.4,2.4,0,0,0,.166.182H14.026a.3.3,0,0,1-.295-.295V1.107q1.541,1.553,3.091,3.1m-.158,19H1.721A.813.813,0,0,1,.8,22.282Q.8,12.005.8,1.729A.817.817,0,0,1,1.736.8Q7.344.8,12.951.8V4.291a1.075,1.075,0,0,0,1.074,1.074h3.555c0,4.991,0,12.011,0,16.91a.815.815,0,0,1-.916.926",
    transform: "translate(787 129.289)",
    fill: "#85af26"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSpreadsheetActive);
export default __webpack_public_path__ + "static/media/icon_spreadsheet_active.10a630de5e1ae459c108d473019c72ac.svg";
export { ForwardRef as ReactComponent };